var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon4LifeIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8596 0H6.14035C2.74913 0 0 2.74913 0 6.14035V28.8596C0 32.2509 2.74913 35 6.14035 35H28.8596C32.2509 35 35 32.2509 35 28.8596V6.14035C35 2.74913 32.2509 0 28.8596 0Z",
    fill: "url(#paint0_linear_226_548)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8711 28.3424C23.3274 27.3952 20.9511 26.6952 21.5375 23.4301C21.9013 23.1875 22.6121 21.6356 23.1755 19.5524C24.2132 19.4634 24.6998 17.9299 24.6998 16.4255C24.6998 15.5044 24.3068 15.2204 23.9507 15.1452C24.2853 10.6981 23.1156 6.14038 17.5002 6.14038C11.8849 6.14038 10.7152 10.6981 11.0529 15.1375C10.6937 15.2127 10.3007 15.5044 10.3007 16.4255C10.3007 17.9299 10.7873 19.4634 11.825 19.5524C12.3899 21.6356 13.0991 23.1875 13.463 23.4301C14.0494 26.7029 11.6731 27.4029 9.12941 28.3424C6.55814 29.2987 3.71362 30.2781 3.1748 34.2371C4.0828 34.7386 5.10333 35.0011 6.14059 35H28.8599C29.8976 34.9997 30.9181 34.7355 31.8257 34.2325C31.2869 30.2781 28.4423 29.2987 25.8711 28.3424Z",
    fill: "url(#paint1_radial_226_548)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5V28.8596C0 30.4882 0.646928 32.05 1.79847 33.2015C2.95001 34.3531 4.51183 35 6.14035 35H28.8596C30.4882 35 32.05 34.3531 33.2015 33.2015C34.3531 32.05 35 30.4882 35 28.8596V17.5H0Z",
    fill: "url(#paint2_linear_226_548)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14021 9.67104C6.01807 9.67104 5.90094 9.62252 5.81457 9.53615C5.72821 9.44979 5.67969 9.33265 5.67969 9.21051V6.14034C5.67969 6.0182 5.72821 5.90106 5.81457 5.81469C5.90094 5.72833 6.01807 5.67981 6.14021 5.67981H9.21039C9.33253 5.67981 9.44966 5.72833 9.53603 5.81469C9.6224 5.90106 9.67092 6.0182 9.67092 6.14034C9.67092 6.26248 9.6224 6.37961 9.53603 6.46598C9.44966 6.55234 9.33253 6.60086 9.21039 6.60086H6.60074V9.21051C6.60074 9.33265 6.55222 9.44979 6.46585 9.53615C6.37949 9.62252 6.26235 9.67104 6.14021 9.67104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8598 29.3202H25.7896C25.6675 29.3202 25.5504 29.2717 25.464 29.1853C25.3776 29.099 25.3291 28.9818 25.3291 28.8597C25.3291 28.7375 25.3776 28.6204 25.464 28.534C25.5504 28.4477 25.6675 28.3992 25.7896 28.3992H28.3993V25.7895C28.3993 25.6674 28.4478 25.5502 28.5342 25.4639C28.6205 25.3775 28.7377 25.329 28.8598 25.329C28.9819 25.329 29.0991 25.3775 29.1854 25.4639C29.2718 25.5502 29.3203 25.6674 29.3203 25.7895V28.8597C29.3203 28.9818 29.2718 29.099 29.1854 29.1853C29.0991 29.2717 28.9819 29.3202 28.8598 29.3202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21039 29.3202H6.14021C6.01807 29.3202 5.90094 29.2717 5.81457 29.1853C5.72821 29.099 5.67969 28.9818 5.67969 28.8597V25.7895C5.67969 25.6674 5.72821 25.5502 5.81457 25.4639C5.90094 25.3775 6.01807 25.329 6.14021 25.329C6.26235 25.329 6.37949 25.3775 6.46585 25.4639C6.55222 25.5502 6.60074 25.6674 6.60074 25.7895V28.3992H9.21039C9.33253 28.3992 9.44966 28.4477 9.53603 28.534C9.6224 28.6204 9.67092 28.7375 9.67092 28.8597C9.67092 28.9818 9.6224 29.099 9.53603 29.1853C9.44966 29.2717 9.33253 29.3202 9.21039 29.3202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8598 9.67104C28.7377 9.67104 28.6205 9.62252 28.5342 9.53615C28.4478 9.44979 28.3993 9.33265 28.3993 9.21051V6.60086H25.7896C25.6675 6.60086 25.5504 6.55234 25.464 6.46598C25.3776 6.37961 25.3291 6.26248 25.3291 6.14034C25.3291 6.0182 25.3776 5.90106 25.464 5.81469C25.5504 5.72833 25.6675 5.67981 25.7896 5.67981H28.8598C28.9819 5.67981 29.0991 5.72833 29.1854 5.81469C29.2718 5.90106 29.3203 6.0182 29.3203 6.14034V9.21051C29.3203 9.33265 29.2718 9.44979 29.1854 9.53615C29.0991 9.62252 28.9819 9.67104 28.8598 9.67104Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_226_548",
    x1: 33.2009,
    y1: 33.2009,
    x2: 1.79912,
    y2: 1.79912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3C55A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BA5DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_226_548",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5002 20.5702) scale(14.3776 14.3776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_226_548",
    x1: 17.5,
    y1: 35,
    x2: 17.5,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5BA5DB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BA5DB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon4LifeIco);
export default __webpack_public_path__ + "static/media/favicon4life-ico.e624883840e92b7f603205b201c9606b.svg";
export { ForwardRef as ReactComponent };